import React from "react";
import Link from "next/link";

import config from "../../config";
import ChevronRight from "./icons/ChevronRight";
import JSONLDTag from "./JSONLDTag";

const JSONLDBreadcrumbList = ({ items }) => {
  const data = {
    itemListElement: items.map(({ path, name }, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name,
      item: `${config.siteRoot}${path}`,
    })),
  };
  return <JSONLDTag type="BreadcrumbList" data={data} />;
};

const BreadcrumbItem = (link, i, links) => (
  <li key={i} className="breadcrumb-item">
    {
      link.useAnchor ? (
        <a href={link.path}>{link.name}</a>
      ) : (
        <Link href={link.path || ""}>
          <a>{link.name}</a>
        </Link>
      )
    }

    {!(i === links.length - 1) && (
      <div className="px-2">
        <ChevronRight />
      </div>
    )}
  </li>
);

const Breadcrumb = ({ items, color = "black" }) => (
  <nav aria-label="breadcrumb" className="overflow-hidden">
    <div className="w-full mx-auto max-w-2xl">
      <div className="flex px-4 whitespace-no-wrap overflow-y-hidden overflow-x-auto">
        <JSONLDBreadcrumbList items={items} />
        <ol className={`breadcrumb text-${color}`}>
          {items.map(BreadcrumbItem)}
        </ol>
      </div>
    </div>
  </nav>
);

export default Breadcrumb;
